import React from 'react'
import ReactDOM from 'react-dom'
import './index.css'
import App from './App'
import reportWebVitals from './reportWebVitals'
import { ChakraProvider } from '@chakra-ui/react'
import { Provider } from 'react-redux'
import store from './Redux/Store'

export const themeConfig = {
  colors: {
    green0: '#9EB0AA',
    green1: '#ECEFEE',
    green2: '#D8DFDD',
    green3: '#C5D0CC',
    green4: '#708A82',
    green5: '#4B5C56',

    green: {
      500: '#708A82',
      600: '#4B5C56',
    },

    yellowgreen: '#CFD5B4',
    yellowgreen1: '#F5F7F0',
    yellowgreen2: '#ECEEE1',
    yellowgreen3: '#E2E6D2',
    yellowgreen4: '#A7B275',
    yellowgreen5: '#747E47',

    darkgrey: '#4F5152',
    darkgrey1: '#DBDCDD',
    darkgrey2: '#B8BABB',
    darkgrey3: '#949798',
    darkgrey4: '#3B3D3E',
    darkgrey5: '#272829',

    yellow: '#FCDD0D',
    yellow1: '#FEF8CF',
    yellow2: '#FEF19E',
    yellow3: '#FDEB6E',
    yellow4: '#C4AB02',
    yellow5: '#837202',

    lightred: '#FD6D50',
    lightred1: '#FFE2DC',
    lightred2: '#FEC5B9',
    lightred3: '#FEA796',
    lightred4: '#F72C03',
    lightred5: '#A51D02',

    red: '#B2101D',
    red1: '#FAC5C9',
    red2: '#F58B93',
    red3: '#EF515E',
    red4: '#860C16',
    red5: '#59080E',

    grey1: '#F2F2F2',
    grey2: '#D9D9D9',
    grey3: '#BFBFBF',
    grey4: '#A6A6A6',
    grey5: '#7F7F7F',

    brown2: '#CB8D67',
  },

  fonts: {
    body: 'Source Sans Pro',
    heading: 'Source Sans Pro',
    mono: 'Menlo, monospace',
  },
}

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <ChakraProvider>
        <App />
      </ChakraProvider>
    </Provider>
  </React.StrictMode>,
  document.getElementById('root'),
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
